<template>
  <v-navigation-drawer
    width="240px"
    color="#fafafb"
    height="100%"
    style="min-height: 90svh"
  >
    <div class="drawer">
      <router-link
        to="/admin"
        class="drawer-item"
        :active-class="$route.path == '/admin' ? 'active' : ''"
      >
        <div class="home-icon" style="margin-right: 14px" />
        Головна
      </router-link>
      <router-link
        to="/admin/services"
        class="drawer-item"
        :active-class="$route.path == '/admin/services' ? 'active' : ''"
      >
        <div class="folder-icon" style="margin-right: 14px" />
        Послуги
      </router-link>
      <router-link
        to="/admin/reviews"
        class="drawer-item"
        :active-class="$route.path == '/admin/reviews' ? 'active' : ''"
      >
        <div class="statistic-icon" style="margin-right: 14px" />
        Відгуки
      </router-link>
      <router-link
        to="/admin/messages"
        class="drawer-item"
        :active-class="$route.path == '/admin/messages' ? 'active' : ''"
      >
        <div class="messages-icon" style="margin-right: 14px" />
        Повідомлення
      </router-link>
      <div style="position: absolute; bottom: 32px">
        <!-- <router-link to="/admin/setting" class="drawer-item">
          <div class="setting-icon" style="margin-right: 14px" />
          Налаштування
        </router-link> -->
        <div class="drawer-item" @click="logout">
          <div class="logout-icon" style="margin-right: 14px" />
          Вихід
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.commit("clearUserLogged");
      this.$router.push('/admin/login')
    },
  },
};
</script>

<style scoped>
.drawer {
  padding: 50px 40px;
  background: #fafafb;
}
.drawer-item {
  height: 38px;
  padding: 8px;
  margin-bottom: 4px;
  color: #3f3f46;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid transparent;
  text-decoration: none;
}
.drawer-item:hover {
  background-color: #ffffff !important;
  border: 1px solid #e4e4e7;
}
.drawer-item.active {
  background-color: #ffffff !important;
  border: 1px solid #e4e4e7;
  color: #1d1d1d;
}
</style>